module.exports = __webpack_public_path__ + "static/media/historie_banner.aeb91f80.jpg";